
















import AbpBase from "@/lib/abpbase"
import {Component} from "vue-property-decorator"
import {GetMachineRepairStatistics} from "@/api/report"

@Component({
	components:{}
})
export default class PatientStatistics extends AbpBase{
	loading = false
	date:any = []
	data:any = []
	query:any = {
		MachineCode: '',
		MachineXlh: '',
		MachineType: -1
	}
	created(){
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
		this.date = [this.formatDate(start), this.formatDate(end)]
		this.getData()
	}
	dateChange(e: any) {
		this.date = e
		this.getData()
	}
	private async getData() {
		this.loading = true
		let query:any = {
			StartDate: this.date[0],
			EndDate: this.date[1],
			MachineCode: this.query.MachineCode,
			MachineXlh: this.query.MachineXlh,
		}
		if (this.query.MachineType !== -1) {
			query['MachineType'] = this.query.MachineType
		}
		let res = await GetMachineRepairStatistics(query)
		this.data = res.objects
		this.loading = false
	}
	options = {
		shortcuts: [
			{
				text: '半年',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 182);
					return [start, end];
				}
			},
			{
				text: '一年',
				value() {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
					return [start, end];
				}
			},

		]
	}
	columns = [
		{
			title: '日期',
			key: 'repairDate'
		},
		{
			title: '机器号',
			key: 'machineCode'
		},
		{
			title: '序列号',
			key: 'machineXlh'
		},
		{
			title: '设备名称',
			key: 'machineName'
		},
		{
			title: '维修人',
			key: 'repairName'
		},
		{
			title: '维修原因',
			key: 'repairReason'
		},
		{
			title: '维修措施',
			key: 'repairMeasures'
		},
		{
			title: '实际费用',
			key: 'actualJe'
		},
		{
			title: '市场费用',
			key: 'marketJe'
		},
		{
			title: '机器类型',
			key: 'machineType'
		},
	]
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/devices/repair.vue